import { createApi } from '@reduxjs/toolkit/query/react';
import rtkBaseQuery from '../../../utils/rtk-base-query';

export const utilsApi = createApi({
  reducerPath: 'utilsApi',
  baseQuery: rtkBaseQuery({ baseUrl: '/api/v2' }),
  endpoints: (builder) => ({
    getFetureToggles: builder.query({
      query: ({ params }) => ({
        url: '/utils/getFeatureToggles',
        method: 'GET',
        body: params,
      }),
    }),
  }),
});

export const { useGetFetureTogglesQuery } = utilsApi;
